import { render } from "./changeEmailaddress.vue?vue&type=template&id=1593ae86&scoped=true&ts=true"
import script from "./changeEmailaddress.vue?vue&type=script&lang=ts"
export * from "./changeEmailaddress.vue?vue&type=script&lang=ts"

import "./changeEmailaddress.vue?vue&type=style&index=0&id=1593ae86&scoped=true&lang=css"

import exportComponent from "D:\\01.Works\\BoonRock\\114.X1Studio\\001.PMS\\31.Dev\\99_source\\crm-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1593ae86"]])

export default __exports__